"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _clientAuth = require("@devsta/client-auth"),
    _FileUploader = _interopRequireDefault(require("./FileUploader")),
    _utils = require("../utils"),
    _constants = require("../constants");

function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");

  return "symbol" === (0, _typeof2["default"])(b) ? b : b + "";
}

function _toPrimitive(a, b) {
  if ("object" !== (0, _typeof2["default"])(a) || null === a) return a;
  var c = a[Symbol.toPrimitive];

  if (c !== void 0) {
    var d = c.call(a, b || "default");
    if ("object" !== (0, _typeof2["default"])(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === b ? String : Number)(a);
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function getAssetPayload(a) {
  var b = a.organisationId,
      c = a.file,
      d = a.metaData;
  return {
    organisationId: b,
    title: c.name,
    filename: c.name,
    metaData: d
  };
}

var AssetUploader = function a(b) {
  var c = this;
  (0, _classCallCheck2["default"])(this, a), this._fileUploaders = {}, this.getNewFileUploader = function (a) {
    var b = new _FileUploader["default"](_objectSpread({
      addUploadTasksToQueue: c._queue.addUploadTasks,
      apiClient: c._apiClient
    }, a));
    return c._fileUploaders[a.assetId] = b, b;
  }, this.getNewHandlers = function (a) {
    var b = a.handleAssetUpdates,
        d = a.totalSize,
        e = a.asset;
    return (0, _utils.createAssetUploaderHandlers)({
      handleAssetUpdates: b,
      onUploadComplete: c.destroyFileUploader(e.assetId),
      asset: e,
      totalSize: d,
      apiClient: c._apiClient
    });
  }, this.createAssets = function () {
    var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.abrupt("return", (0, _utils.createAssets)(c._apiClient, b.map(getAssetPayload)));

            case 1:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }(), this.uploadAsset = function () {
    var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
      var d, e, f, g, h, i, j, k;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              d = b.asset, e = b.handleAssetUpdates, f = b.file, e([_objectSpread(_objectSpread({}, d), {}, {
                loaded: 0,
                loadedPercent: 0,
                totalSize: f.size,
                uploadStatus: _constants.ITEM_STATUS.DEFAULT
              })]), g = c.getNewHandlers({
                handleAssetUpdates: e,
                asset: d,
                totalSize: f.size
              }), h = d.assetId, i = d.organisationId, j = d.metaData, k = d.assetFiles.ORIGINAL, c.getNewFileUploader(_objectSpread({
                bucketKey: "organisation/".concat(i, "/asset/").concat(h, "/file"),
                file: f,
                ORIGINAL: k,
                assetId: h,
                organisationId: i,
                metaData: j
              }, g)).start();

            case 5:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }(), this.destroyFileUploader = function (a) {
    return function () {
      var b = c._fileUploaders,
          d = b[a],
          e = (0, _objectWithoutProperties2["default"])(b, [a].map(_toPropertyKey));
      d && (d.destroy(), c._fileUploaders = e);
    };
  }, this.retryAssetUpload = function () {
    var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
      var d, e, f, g, h, i, j, k, l, m, n, o;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (d = b.handleAssetUpdates, e = b.file, f = b.assetId, g = b.organisationId, h = (0, _utils.getAssetFromLocalStorage)(f), h && (0, _utils.isAssetInLocalStorage)(h, e)) {
                a.next = 4;
                break;
              }

              return a.abrupt("return");

            case 4:
              i = h.bucketKey, j = h.assetFiles, k = h.metaData, l = _clientAuth.credentials.get(), m = l.user, n = {
                assetId: f,
                organisationId: g,
                assetFiles: j,
                metaData: k,
                filename: e.name,
                createdByUser: m,
                updatedByUser: m
              }, d([n]), o = c.getNewHandlers({
                handleAssetUpdates: d,
                asset: n,
                totalSize: e.size
              }), o.progress(h.uploadedBytes), c.getNewFileUploader(_objectSpread({
                bucketKey: i,
                file: e,
                assetId: f,
                organisationId: g,
                ORIGINAL: j.ORIGINAL,
                metaData: k,
                cacheUploadId: h.uploadId,
                uploadedParts: h.uploadedParts,
                uploadedBytes: h.uploadedBytes
              }, o)).start();

            case 11:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }(), this.cancelAssetUpload = function (a) {
    var b = a.assetId;
    c.destroyFileUploader(b)(), c._queue.removeUploadTasks(b);
  }, this._apiClient = b, this._queue = new _utils.Queue();
},
    _default = AssetUploader;

exports["default"] = _default;